/**
 * Store web sites list
 *
 * @param state
 * @param payload
 */

export function TOGGLE_COLORIZE(state) {
  state.colorize = !state.colorize;
}
export function TOGGLE_COLOR_LEGEND(state) {
  state.showColorLegend = !state.showColorLegend;
}